<template>
    <div>
      <h2>Confirm Your Discount</h2>
      <p>Discount Hours: {{ discountHours }}</p>
      <button @click="proceed">Confirm</button>
    </div>
  </template>
  
  <script>
  export default {
    props: ['discountHours'],
    methods: {
      proceed() {
        this.$emit('nextStep');
      }
    }
  };
  </script>
  
  <style scoped>
  h2 {
    margin: 20px 0;
  }
  p {
    margin-bottom: 10px;
    color: #333;
  }
  button {
    padding: 10px;
    background-color: #2196F3;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  </style>
  